/**
 * Judge.me slim-down:
 * - Product: defer review_widget (+ form) until #judgeme_product_reviews is near viewport
 * - Non-product (esp. home): never load widget_form.js / write-review modal assets
 * - Rewrite review-images __original → __compact thumbnails (lightbox keeps original)
 */
(function () {
  'use strict';

  var cfg = window.__jdgmSlim || {};
  var isProduct = !!cfg.isProduct;
  var released = !isProduct;
  var queue = [];
  var JDGM_HOST = /judgeme|jdgm|01a11b30-98d5|review-images\.judgeme/i;
  var FORM_ASSET = /widget_form\.js|widget_v3_form\.css|widget_write_review_modal/i;
  var DEFER_ASSET = /review_widget\.js|widget_form\.js|widget_v3_form\.css|widget_write_review_modal|widget_common\.js|widget_main\.js/i;
  var LIGHTBOX = '.jdgm-lightbox,.jdgm-gallery-popup,.jdgm-full-rev-modal,[class*="Lightbox"],[class*="lightbox"]';

  function urlOf(node) {
    if (!node || node.nodeType !== 1) return '';
    return node.src || node.href || '';
  }

  function isJdgmNode(node) {
    if (!node || node.nodeType !== 1) return false;
    var tag = node.tagName;
    if (tag !== 'SCRIPT' && tag !== 'LINK') return false;
    return JDGM_HOST.test(urlOf(node));
  }

  function shouldDrop(url) {
    return !isProduct && FORM_ASSET.test(url);
  }

  function shouldDefer(url) {
    return isProduct && !released && DEFER_ASSET.test(url);
  }

  function flushQueue() {
    if (released) return;
    released = true;
    var items = queue.slice();
    queue = [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      try {
        item.orig.apply(item.parent, item.args);
      } catch (e) {}
    }
  }

  function patchMethod(proto, name) {
    var orig = proto[name];
    if (!orig || orig.__jdgmSlim) return;
    var wrapped = function () {
      var node = arguments[0];
      if (isJdgmNode(node)) {
        var url = urlOf(node);
        if (shouldDrop(url)) return node;
        if (shouldDefer(url)) {
          queue.push({ parent: this, args: arguments, orig: orig });
          return node;
        }
      }
      return orig.apply(this, arguments);
    };
    wrapped.__jdgmSlim = true;
    proto[name] = wrapped;
  }

  patchMethod(Node.prototype, 'appendChild');
  patchMethod(Node.prototype, 'insertBefore');

  function stripFormLinks(root) {
    if (isProduct || !root || !root.querySelectorAll) return;
    var nodes = root.querySelectorAll(
      'link[href*="widget_form"],link[href*="widget_v3_form"],link[href*="widget_write_review"],script[src*="widget_form"],script[src*="widget_write_review"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      try {
        nodes[i].remove();
      } catch (e) {}
    }
  }

  if (!isProduct) {
    var formMo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          var u = urlOf(n);
          if (u && shouldDrop(u)) {
            try {
              n.remove();
            } catch (e) {}
          } else {
            stripFormLinks(n);
          }
        }
      }
    });
    formMo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      formMo.disconnect();
    }, 12000);
  }

  function findReviewRoot() {
    return (
      document.getElementById('judgeme_product_reviews') ||
      document.querySelector('.jdgm-review-widget, .jdgm-rev-widg, [data-entry-point*="review_widget"]')
    );
  }

  function watchProductWidget() {
    if (!isProduct) return;

    if (location.hash && /judge|review/i.test(location.hash)) {
      flushQueue();
      return;
    }

    function arm(el) {
      if (!('IntersectionObserver' in window)) {
        flushQueue();
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              io.disconnect();
              flushQueue();
              break;
            }
          }
        },
        { rootMargin: '400px 0px', threshold: 0.01 }
      );
      io.observe(el);
    }

    var el = findReviewRoot();
    if (el) {
      arm(el);
      return;
    }

    var mo = new MutationObserver(function () {
      var found = findReviewRoot();
      if (found) {
        mo.disconnect();
        arm(found);
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      mo.disconnect();
      var late = findReviewRoot();
      if (late) arm(late);
    }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchProductWidget);
  } else {
    watchProductWidget();
  }

  function toThumb(url) {
    return String(url).replace(/__original/g, '__compact');
  }

  function inLightbox(img) {
    return !!(img.closest && img.closest(LIGHTBOX));
  }

  function rewriteImg(img) {
    if (!img || img.nodeType !== 1 || img.tagName !== 'IMG') return;
    if (inLightbox(img)) return;

    var src = img.getAttribute('src') || '';
    if (src.indexOf('review-images.judgeme') !== -1 && src.indexOf('__original') !== -1) {
      img.setAttribute('src', toThumb(src));
    }

    var srcset = img.getAttribute('srcset') || '';
    if (srcset.indexOf('__original') !== -1) {
      img.setAttribute('srcset', toThumb(srcset));
    }
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    var imgs = root.querySelectorAll('img[src*="review-images.judgeme"], img[srcset*="__original"]');
    for (var i = 0; i < imgs.length; i++) rewriteImg(imgs[i]);
  }

  try {
    var desc = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
    if (desc && desc.set && desc.get) {
      Object.defineProperty(HTMLImageElement.prototype, 'src', {
        configurable: true,
        enumerable: desc.enumerable,
        get: desc.get,
        set: function (value) {
          if (
            typeof value === 'string' &&
            value.indexOf('review-images.judgeme') !== -1 &&
            value.indexOf('__original') !== -1 &&
            !inLightbox(this)
          ) {
            value = toThumb(value);
          }
          desc.set.call(this, value);
        }
      });
    }
  } catch (e) {}

  function startThumbObserver() {
    scan(document);
    var imgMo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes' && m.target && m.target.tagName === 'IMG') {
          rewriteImg(m.target);
          continue;
        }
        var added = m.addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'IMG') rewriteImg(n);
          else scan(n);
        }
      }
    });
    imgMo.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset']
    });
  }

  if (document.body) startThumbObserver();
  else document.addEventListener('DOMContentLoaded', startThumbObserver);
})();
